import React from 'react';
import { Card } from '../components/ui/card';
import { AlertTriangle, ShieldAlert } from 'lucide-react';

const VapeProducts = () => {
  const displayImages = [
    {
      url: process.env.REACT_APP_VAPE_IMAGE_1,
      alt: 'MR FOG Switch/Nova Series Display',
      caption: 'MR FOG - Full Selection Available'
    },
    {
      url: process.env.REACT_APP_VAPE_IMAGE_2,
      alt: 'GEEK BAR Pulse Series Display',
      caption: 'GEEK BAR Pulse & Premium Brands'
    },
    {
      url: process.env.REACT_APP_VAPE_IMAGE_3,
      alt: 'Complete Vape Product Display',
      caption: 'MR FOG, FOGER, RAZ & More'
    }
  ];

  const brands = [
    {
      name: 'MR FOG',
      subtitle: 'Switch / Nova Series',
      description: 'High-puff disposable options up to 45K puffs',
      status: 'IN STOCK',
      flavors: [
        'Blueberry', 'Strawberry', 'Peach', 'Watermelon', 'Mango', 'Pineapple',
        'Grape', 'Cherry', 'Mixed Berry', 'Mint / Menthol', 'Sour Apple',
        'Strawberry Banana', 'Peach Ice', 'Watermelon Ice', 'Blue Raspberry', 'Strawberry Ice'
      ]
    },
    {
      name: 'GEEK BAR',
      subtitle: 'Pulse Series',
      description: 'Pulse technology with long-lasting disposable design',
      status: 'IN STOCK',
      flavors: [
        'Blue Razz Ice', 'Strawberry Banana', 'Sour Apple Ice', 'Peach Ice',
        'Watermelon Ice', 'Pink Lemonade', 'Miami Mint', 'Cool Mint',
        'Mixed Berry', 'Grape Ice'
      ]
    },
    {
      name: 'FOGER',
      subtitle: 'Disposable Vapes',
      description: 'Premium build with high puff counts (25K–35K)',
      status: 'IN STOCK',
      flavors: [
        'Strawberry Cupcake', 'Juicy Peach', 'Blue Razz Ice', 'Watermelon Ice',
        'Passion Kiwi', 'Strawberry Burst'
      ]
    },
    {
      name: 'RAZ',
      subtitle: 'Disposable Vapes',
      description: 'Bold flavors with compact design',
      status: 'IN STOCK',
      flavors: [
        'Blue Razz Ice', 'Strawberry Ice', 'Watermelon Ice', 'Tropical Blends'
      ]
    },
    {
      name: 'LOOPER',
      subtitle: 'Premium Vapes',
      description: 'Live Resin editions with hybrid blends',
      status: 'IN STOCK',
      flavors: [
        'Live Resin Edition', 'Fruit Blends', 'Candy-Style Flavors', 'Hybrid Blends'
      ]
    }
  ];

  return (
    <div>
      {/* Hero Section */}
      <section className="section section-blue">
        <div className="container max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="premium-badge-red mb-6">21+ Only</div>
          <h1 className="text-5xl md:text-6xl font-black mb-6">Vape & Nicotine Products</h1>
          <div className="section-divider" style={{ background: 'linear-gradient(90deg, var(--white) 0%, var(--marathon-red) 50%, var(--white) 100%)' }}></div>
          <p className="text-xl md:text-2xl mt-6" style={{ color: 'rgba(255, 255, 255, 0.95)' }}>
            Premium Selection Available In-Store
          </p>
        </div>
      </section>

      {/* Warning Section */}
      <section className="section section-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <Card 
            className="p-8 border-4 mb-12"
            style={{ 
              borderColor: 'var(--marathon-red)',
              backgroundColor: 'rgba(239, 68, 68, 0.05)'
            }}
          >
            <div className="flex items-start space-x-4">
              <div 
                className="w-16 h-16 rounded-2xl flex items-center justify-center flex-shrink-0"
                style={{ 
                  background: 'linear-gradient(135deg, var(--marathon-red) 0%, var(--marathon-red-dark) 100%)',
                  color: 'white'
                }}
              >
                <AlertTriangle size={32} />
              </div>
              <div>
                <h3 className="text-2xl font-black mb-3" style={{ color: 'var(--marathon-red)' }}>
                  NICOTINE WARNING
                </h3>
                <p className="text-lg font-semibold mb-2" style={{ color: 'var(--gray-900)' }}>
                  WARNING: This product contains nicotine. Nicotine is an addictive chemical.
                </p>
                <p className="text-base font-medium" style={{ color: 'var(--gray-700)' }}>
                  Must be 21+ years of age to purchase. Valid ID required.
                </p>
              </div>
            </div>
          </Card>

          {/* Age Verification Notice */}
          <div 
            className="text-center p-6 rounded-xl mb-12"
            style={{ 
              background: 'linear-gradient(135deg, var(--marathon-blue) 0%, var(--marathon-blue-dark) 100%)',
              color: 'white'
            }}
          >
            <div className="flex items-center justify-center space-x-3 mb-2">
              <ShieldAlert size={24} />
              <span className="text-xl font-bold">Age Verification Required</span>
            </div>
            <p className="text-sm">We verify age for all vape product purchases in accordance with federal and state regulations.</p>
          </div>
        </div>
      </section>

      {/* Our Display - Actual Store Photos */}
      <section className="section section-light">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-black mb-4" style={{ color: 'var(--marathon-blue)' }}>
              Our Selection
            </h2>
            <div className="section-divider"></div>
            <p className="text-lg mt-6" style={{ color: 'var(--gray-700)' }}>
              Browse our retail display of premium vape products
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-16">
            {displayImages.map((image, index) => (
              <Card 
                key={index}
                className="elevated-card overflow-hidden"
              >
                <div className="relative">
                  <img 
                    src={image.url}
                    alt={image.alt}
                    className="w-full h-80 object-cover"
                  />
                  <div 
                    className="absolute bottom-0 left-0 right-0 p-4"
                    style={{ 
                      background: 'linear-gradient(to top, rgba(0, 0, 0, 0.8) 0%, transparent 100%)'
                    }}
                  >
                    <p className="text-white font-bold text-center">{image.caption}</p>
                  </div>
                </div>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* Products by Brand */}
      <section className="section section-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-black mb-4" style={{ color: 'var(--marathon-blue)' }}>
              Brands & Flavors
            </h2>
            <div className="section-divider"></div>
            <p className="text-lg mt-6" style={{ color: 'var(--gray-700)' }}>
              Premium disposable vapes from trusted manufacturers
            </p>
          </div>

          <div className="space-y-12">
            {brands.map((brand, brandIndex) => (
              <Card 
                key={brandIndex}
                className="elevated-card"
              >
                {/* Brand Header */}
                <div className="mb-8 pb-6 border-b-2" style={{ borderColor: 'var(--gray-200)' }}>
                  <div className="flex items-center justify-between mb-4">
                    <div>
                      <h3 className="text-3xl font-black mb-2" style={{ color: 'var(--marathon-blue)' }}>
                        {brand.name}
                      </h3>
                      <p className="text-lg font-semibold" style={{ color: 'var(--marathon-red)' }}>
                        {brand.subtitle}
                      </p>
                    </div>
                    <div 
                      className="premium-badge-yellow"
                      style={{ fontSize: '12px', padding: '6px 16px' }}
                    >
                      {brand.status}
                    </div>
                  </div>
                  <p className="text-base" style={{ color: 'var(--gray-600)' }}>
                    {brand.description}
                  </p>
                </div>

                {/* Flavors Grid */}
                <div>
                  <h4 className="text-lg font-bold mb-4" style={{ color: 'var(--gray-800)' }}>
                    Available Flavors:
                  </h4>
                  <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
                    {brand.flavors.map((flavor, flavorIndex) => (
                      <div
                        key={flavorIndex}
                        className="p-4 rounded-lg text-center"
                        style={{
                          backgroundColor: 'var(--gray-50)',
                          border: '2px solid var(--gray-200)'
                        }}
                      >
                        <span className="text-sm font-semibold" style={{ color: 'var(--gray-800)' }}>
                          {flavor}
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* Visit Us CTA */}
      <section className="section section-blue">
        <div className="container max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-black mb-6">Visit Our Store</h2>
          <p className="text-xl mb-8" style={{ color: 'rgba(255, 255, 255, 0.95)' }}>
            All vape products available in-store at Hope Tobacco.<br />
            <span className="font-bold">704 Main St, Hope, Indiana</span><br />
            <span className="font-bold">Valid ID required for purchase. Must be 21+</span>
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a href="tel:8125465780">
              <button
                className="px-8 py-4 rounded-lg text-lg font-bold"
                style={{
                  background: 'linear-gradient(135deg, var(--marathon-red) 0%, var(--marathon-red-light) 100%)',
                  color: 'white'
                }}
              >
                Call: (812) 546-5780
              </button>
            </a>
          </div>
        </div>
      </section>

      {/* Legal Disclaimer Footer */}
      <section className="py-8" style={{ backgroundColor: 'var(--gray-900)', color: 'var(--white)' }}>
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <p className="text-sm mb-2" style={{ color: 'var(--gray-400)' }}>
            <strong>Legal Notice:</strong> The sale of tobacco and nicotine products to persons under 21 years of age is prohibited by law.
          </p>
          <p className="text-xs" style={{ color: 'var(--gray-500)' }}>
            Products displayed are subject to availability. Hope Tobacco complies with all federal, state, and local tobacco regulations.
          </p>
        </div>
      </section>
    </div>
  );
};

export default VapeProducts;
